<template>
  <div class="main-uctoolbar">
    <f7-toolbar
      class="content-toolbar-elements"
      tabbar
      :position="isBottom ? 'bottom' : 'top'"
    >
      <slot
        v-if="tabbarLink === '1'"
        name="link1"
      >
        <f7-link
          v-for="(tab, i) in dataTabs"
          :key="i"
          :tab-link="tab.tablink ? `#tab-${tab.tablink}` : `#tab-${i + 1}`"
          :tab-link-active="i === 0"
          @click="EventOnClick(tab)"
        >
          <slot name="title">
            <div
              class="content-title display-flex"
              :class="{ 'content-title-badge': tab.badge }"
            >
              <span class="content-title">{{ tab.title }}</span>
              <f7-badge
                v-if="tab.badge"
                class="content-badge"
              >
                {{ (tab.badge).toString() }}
              </f7-badge>
            </div>
          </slot>
        </f7-link>
      </slot>

      <slot
        v-else
        name="link"
      >
        <f7-link
          tab-link="#tab-1"
          :href="href1 !== null ? href1 : false"
          :tab-link-active="tabLinkActive === '1' ? true : false"
          @click="eventOnClick1"
        >
          {{ titleTab1 }}
        </f7-link>
        <f7-link
          tab-link="#tab-2"
          :href="href2 !== null ? href2 : false"
          :tab-link-active="tabLinkActive === '2' ? true : false"
          @click="eventOnClick2"
        >
          {{ titleTab2 }}
        </f7-link>
        <f7-link
          v-if="titleTab3 !== null"
          tab-link="#tab-3"
          :href="href3 !== null ? href3 : false"
          :tab-link-active="tabLinkActive === '3' ? true : false"
          @click="eventOnClick3"
        >
          {{ titleTab3 }}
        </f7-link>
      </slot>
    </f7-toolbar>
    <slot name="tabs" />
  </div>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';

export default {
  name: 'UCToolbar',
  props: {
    data: { type: Array, default: () => [] },
    isBottom: { type: Boolean, default: true },
    tabbarLink: { type: String, default: '2' },
    tabLinkActive: { type: String, default: '1' },
    titleTab1: { type: String, default: null },
    href1: { type: String, default: null },
    href2: { type: String, default: null },
    href3: { type: String, default: null },
    titleTab2: { type: String, default: null },
    titleTab3: { type: String, default: null },
  },

  emits: [
    'on-click',
    'on-click-1',
    'on-click-2',
    'on-click-3',
  ],
  data() {
    return {
      dataTabs: [],
    };
  },
  watch: {
    data(value) {
      if (value) {
        this.dataTabs = value;
      }
    },
  },
  mounted() {
    this.dataTabs = this.data;
  },

  methods: {
    EventOnClick(tab) {
      Log(this, this.EventOnClick.name);
      this.$emit('on-click', tab);
    },
    eventOnClick1() {
      this.$emit('on-click-1');
    },
    eventOnClick2() {
      this.$emit('on-click-2');
    },
    eventOnClick3() {
      this.$emit('on-click-3');
    },
  },
};
</script>

<style scoped lang="scss">
.main-uctoolbar {
  .toolbar-top {
    top: 0;
  }

  .content-toolbar-elements {
    height: var(--toolbar-height);
    background-color: var(--toolbar-bg-color);

    // color: var(--toolbar-text-color);
    font-size: var(--toolbar-font-size);
  }
}
</style>
